import React from "react";
import { Link } from "react-router-dom";
import { Briefcase, ArrowRight } from "lucide-react";

const ContractEmployees = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold mb-8 text-gray-800">
          Contract Employees
        </h1>
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="flex items-center mb-4">
            <Briefcase className="w-12 h-12 text-red-500 mr-4" />
            <p className="text-xl text-gray-700">
              Skilled professionals for project-based work.
            </p>
          </div>
          <p className="text-gray-600 mb-4">
            Our Contract Employees service provides highly skilled professionals
            for your project-based needs. Whether you require specialized
            expertise or additional support for a specific duration, we have the
            right talent for your projects.
          </p>
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            How It Works
          </h2>
          <ol className="list-decimal list-inside mb-6 text-gray-700">
            <li className="mb-2">
              You define your project requirements and timeline
            </li>
            <li className="mb-2">
              We source contractors with relevant skills and experience
            </li>
            <li className="mb-2">
              You interview and select the best candidates
            </li>
            <li className="mb-2">
              Contractors join your team for the project duration
            </li>
            <li>We manage contracts and ensure smooth project completion</li>
          </ol>
          <Link
            to="/contact"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center text-lg font-semibold"
          >
            Get Started <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </main>
    </div>
  );
};

export default ContractEmployees;
